import { useEffect, useState } from "react";
import Card from "../../../../components/Card/Card";
import List from "../../../../components/List/List";
import Pagination from "../../../../components/Pagination/Pagination";
import { useAuth } from "../../../../contexts/auth";
import "./ListGroups.css";
import GroupService from "../../../../services/GroupsService";

const ListGroups = (props) => {
	const [groups, setGroups] = useState([]);
	const [maxPage, setMaxPage] = useState(1);
	const [collumnClicked, setCollumnClicked] = useState({
		collumnTitle: "updated_at",
		orderDirection: "DESC",
	});
	const { user } = useAuth();
	const [isLoading, setIsLoading] = useState(true);

	const clientData = user.userData.selectedOrganizationId;

	const getGroups = async (page, searchText, clientID, orderBy) => {
		setIsLoading(true);
		try {
			const response = await GroupService.getPaginated(
				page,
				searchText,
				clientID,
				orderBy
			);
			if (response && response.data) {
				const paginated = response.data;
				setGroups(paginated.items);
				setMaxPage(paginated.pagination.totalPages);
			}
		} catch (error) {
			console.error(error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getGroups(1, props.filters, clientData, collumnClicked);
	}, [user, props.filters, collumnClicked, clientData, props.refreshKey]);

	return (
		<>
			<div className="list-container list-visibility">
				<List
					isLoading={isLoading}
					lineSelected={props.lineSelected}
					handleCollumnTitleClick={(col) => setCollumnClicked(col)}
					collumsObjIndex={[
						{ collumnLabel: "Nome", index: "name", type: "text" },
						{
							collumnLabel: "Políticas", type: "text", custom: ({ row }) => {
								return (row.policies && row.policies.length > 0) ? row.policies.length : <span style={{ opacity: 0.36 }}>Não consta</span>;
							}
						},
						{ collumnLabel: "Criado em", index: "organizationName", type: "text" },
					]}
					data={groups?.map((group) => ({
						...group,
					}))}
				/>
			</div>
			<div className="card-visibility">
				{groups?.map((group, index) => (
					<Card
						key={group.id || index}
						data={group}
						delete={() => { }}
						navigateOnDelete={""}
						navigateOnEdit={""}
					>
						<p className="card-content-title">{group.name}</p>
					</Card>
				))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					getGroups(page, props.filters, clientData.id, collumnClicked)
				}
			/>
		</>
	);
};

export default ListGroups;
